import { request } from '@/utils'

export default {

  // 获取 banner 文章
  async findBanner() {
    return request({
      path: '/article/banner'
    })
  },

  // 获取指定文章内容
  async findMessages(id) {
    return request({
      path: `/article/${id}`
    })
  },

  // 获取首页动态信息
  async findHomeInformation() {
    return request({
      path: '/information/latest'
    })
  },

  // 获取首页学术文章
  async findHomeScienceArticle() {
    return request({
      path: '/scienceArticle/latest'
    })
  },

  // 获取基地列表
  async findBase(category) {
    return request({
      path: '/base',
      query: {
        category,
      }
    })
  },

  // 获取指定类型的文字
  async findScienceArticle(category) {
    return request({
      path: '/scienceArticle',
      query: {
        category,
      }
    })
  },

  // 获取研究方向
  findResearchDirections() {
    return request({
      path: '/teacherResearch'
    })
  },

  // 获取指定类型的文字
  async searchScienceArticle(category, word) {
    return request({
      path: '/search/article',
      query: {
        category,
        word,
      }
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/home.js